

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { signedUploadService } from '@/services/SignedUploadService';

@Component({})

export default class FileUploadPreview extends Vue {
  @Prop() currentFiles!: any[];

  public files: any[] = [];
  public deletedFiles: string[] = [];
  public $refs!: {
    fileInput: HTMLInputElement;
  };

  public created(): void {
    this.files = this.files.concat(this.currentFiles);
  }

  public fileOpen(): void {
    this.$refs.fileInput.click();
  }

  public fileDelete(index: number): void {
    const attachment = this.files[index];
    if (attachment.id) {
      this.deletedFiles.push(attachment.id);
    }
    this.files.splice(index, 1);
  }

  public fileAdd(e: Event): void {
    const files = this.$refs.fileInput.files || [];
    for (let i = 0; i < files.length; i += 1) { // tslint:disable-line
      const file = files[i];
      signedUploadService.startClientUpload(file)
        .then((resFields) => {
          const url = URL.createObjectURL(file);
          this.files.unshift({
            url,
            key: resFields.key,
            name: file.name
          });
        })
        .catch((er: any) => {
          this.$emit('errors', er.message);
        });
    }
  }

  @Watch('files')
  public onFilesChange() {
    const newFiles = this.files.filter(attach => attach.key);
    this.$emit('addAttachments', newFiles.map((f) => {
      return { key: f.key };
    }));
  }

  @Watch('deletedFiles')
  public onFilesDelete() {
    this.$emit('deleteAttachments', this.deletedFiles);
  }
}

